<template>
  <v-container class="content">
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />

    <!-- Popup Nav Header -->
    <div class="nav" @click="goBack">
      <v-icon size="12px" color="#00457C">arrow_back_ios</v-icon>Back
    </div>
    <div class="header text-left">Edit Homepage Service Item</div>

    <!-- Image Upload -->
    <v-row class="photo-label">
      <v-col cols="3">
        <label for="cover-photo">Icon</label>
      </v-col>
    </v-row>
    <v-row class="photo-picker">
      <v-col cols="6" md="8">
        <input disabled id="cover-photo" type="text" v-model="imageFileName" />
        <br />
        <input
          style="display: none"
          ref="imageFileInput"
          type="file"
          accept="image/x-png, image/jpeg"
          @change="(e) => setImage(e.target.files[0])"
        />
      </v-col>
      <v-col cols="2">
        <label v-on:click="clickImageInput" id="browse-btn">Browse</label>
      </v-col>
    </v-row>

    <!-- Title -->
    <v-row>
      <v-col cols="12">
        <label for="ann-title">Service Name</label>
        <input
          id="ann-title"
          type="text"
          v-model="title"
          @input="$v.title.$touch()"
        />
        <div class="error-msg" v-show="$v.title.$invalid && $v.title.$dirty">
          This is a required field.
        </div>
        <br />
      </v-col>
    </v-row>

    <!-- Button Configurations -->
    <v-row>
      <v-col cols="4" md="4">
        <label for="ann-btn-url">Page Link</label>
        <select v-model="pageLink">
          <option></option>
          <option>Consignment</option>
          <option>E-Value</option>
          <option>Rewards</option>
          <option>Profile</option>
          <option>Shop</option>
          <option>Stores</option>
          <option>Videos</option>
          <option>Payment Option Dialog</option>
          <option>Instalment Summary</option>
          <option>Ticket Summary</option>
          <option>Stamp Card</option>
          <option>Wheels</option>
          <option>More Options</option>
        </select>
      </v-col>
      <v-col cols="4" md="8">
        <label for="ann-btn-url">Page URL</label>
        <input
          id="ann-btn-url"
          type="text"
          v-model="redirectUrl"
          @input="$v.redirectUrl.$touch()"
        />
        <div
          class="error-msg"
          v-show="$v.redirectUrl.$invalid && $v.redirectUrl.$dirty"
        >
          Please enter a URL in the following format: http://www.example.com/.
        </div>
      </v-col>
    </v-row>

    <!-- Title -->
    <v-row>
      <v-col cols="3">
        <label for="ann-row">Row</label>
        <input
          id="ann-row"
          type="text"
          v-model="row"
          @input="$v.row.$touch()"
        />
        <div class="error-msg" v-show="$v.row.$invalid && $v.row.$dirty">
          This is a required field.
        </div>
        <br />
      </v-col>
      <v-col cols="3">
        <label for="ann-column">Column</label>
        <input
          id="ann-column"
          type="text"
          v-model="column"
          @input="$v.column.$touch()"
        />
        <div class="error-msg" v-show="$v.column.$invalid && $v.column.$dirty">
          This is a required field.
        </div>
        <br />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3">
        <label for="ann-title">Enable</label>
        <v-switch v-model="isEnabled"></v-switch>
        <br />
      </v-col>
      <v-col cols="3">
        <label for="ann-title">Include in More Services</label>
        <v-switch v-model="isMoreServices"></v-switch>
        <br />
      </v-col>
    </v-row>

    <!-- Form Submit Button -->
    <v-row>
      <v-col cols="4" md="3">
        <v-btn color="#00457C" @click="updateForm">Submit</v-btn>
      </v-col>
    </v-row>

    <v-row v-if="success">
      <v-col cols="12">
        <v-alert type="success">Service updated successfully.</v-alert>
      </v-col>
    </v-row>

    <v-row v-if="error">
      <v-col cols="12">
        <v-alert type="error">Error occurred. Please try again.</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Axios from "axios";
import { required, url } from "vuelidate/lib/validators";
import LoadingScreen from "./commons/LoadingScreen";

//sets btn link as valid if btn url is not selected and vice versa
let checkLink = (value, vm) => {
  if (vm.redirectUrl === "") {
    if (vm.pageLink !== "") {
      return true;
    } else {
      return false;
    }
  }

  if (vm.pageLink === "") {
    if (vm.redirectUrl !== "") {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export default {
  components: {
    LoadingScreen,
  },

  data() {
    return {
      title: "",
      pageLink: "",
      redirectUrl: "",
      imageUrl: "",
      imageFile: null,
      imageFileName: "",
      loading: false,
      success: false,
      error: false,
      isEnabled: true,
      isMoreServices: false,
      row: null,
      column: null,
      selectedId: this.$route.params.itemId,
    };
  },

  validations: {
    title: {
      required,
    },
    pageLink: {
      checkLink,
    },
    redirectUrl: {
      checkLink,
      url,
    },
    row: {
      required,
    },
    column: {
      required,
    },
  },

  mounted() {
    Axios.get(
      process.env.VUE_APP_HOST_SERVER + "/api/services/" + this.selectedId
    )
      .then((res) => {
        console.log(res);
        this.title = res.data.title;
        this.pageLink = res.data.pageLink;
        this.redirectUrl = res.data.redirectUrl;
        this.imageUrl = res.data.imageUrl;
        this.row = res.data.row;
        this.column = res.data.column;
        this.isEnabled = res.data.isEnabled;
        this.isMoreServices = res.data.isMoreServices;
        this.imageFileName = res.data.imageUrl.slice(82);
      })
      .catch((err) => console.log(err));
  },

  methods: {
    goBack() {
      this.$router.push({ name: "HomepageServices" }).catch(() => {});
    },
    // TODO: validate redirect url to have http://
    // TODO: validate image to be of a certain aspect ratio
    setImage(file) {
      if (file !== null) {
        // Set image file
        this.imageFile = file;
        this.imageFileName = file.name;
      }
    },
    updateForm() {
      console.log(this.imageFile);
      if (this.imageFile !== null) {
        this.loading = true; //enable loading screen once user clicks submit

        const HomepageServicesData = new FormData();
        HomepageServicesData.append("imageFile", this.imageFile);

        Axios.post(
          process.env.VUE_APP_HOST_SERVER + "/api/image_upload/services",
          HomepageServicesData,
          { headers: { "Content-Type": "multipart/form-data" } }
        )
          .then((res) => {
            console.log(
              "Successfully uploaded services image ",
              res.data.imageUrl
            );
            const imageUrl = res.data.imageUrl;

            const updatedDetails = {
              title: this.title,
              pageLink: this.pageLink,
              redirectUrl: this.redirectUrl,
              imageUrl: imageUrl,
              row: this.row,
              column: this.column,
              isEnabled: this.isEnabled,
              isMoreServices: this.isMoreServices,
            };

            // Update Mongodb
            Axios.put(
              process.env.VUE_APP_HOST_SERVER +
                `/api/services/update/${this.selectedId}`,
              updatedDetails
            )
              .then((res) => {
                console.log(res);
                this.loading = false; //disable loading screen once request is handled
                this.success = true; //show success message
                this.error = false;
                console.log(
                  "Successfully updated the service ",
                  updatedDetails
                );
              })
              .catch((err) => {
                console.log(err);
                this.error = true;
              });
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        const updatedDetails = {
          title: this.title,
          pageLink: this.pageLink,
          redirectUrl: this.redirectUrl,
          imageUrl: this.imageUrl,
          row: this.row,
          column: this.column,
          isEnabled: this.isEnabled,
        };

        // Update Mongodb
        Axios.put(
          process.env.VUE_APP_HOST_SERVER +
            `/api/services/update/${this.selectedId}`,
          updatedDetails
        )
          .then((res) => {
            console.log(res);
            this.loading = false; //disable loading screen once request is handled
            this.success = true; //show success message
            this.error = false;
            console.log("Successfully updated the service ", updatedDetails);
          })
          .catch((err) => {
            console.log(err);
            this.error = true;
          });
      }
    },
    clickImageInput() {
      this.$refs.imageFileInput.click();
    },
  },
};
</script>

<style scoped>
.content {
  box-shadow: 0px 1px 20px rgba(163, 163, 163, 0.25);
  border: 1px solid #eeeeee;
  padding: 25px;
  text-align: initial;
}

.content .row {
  padding-bottom: 18px;
}

.content .row:nth-last-child(1) {
  padding-bottom: 0;
}

.content .nav {
  color: #00457c;
  font-weight: bold;
  margin-bottom: 40px;
  font-size: 16px;
  cursor: pointer;
}

.content .header {
  font-size: 26px;
  margin-bottom: 20px;
  font-weight: normal;
}

.content button {
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: white;
  text-transform: none;
  letter-spacing: normal;
}

label {
  font-size: 14px;
  color: #6f6f6f;
  margin-bottom: 10px;
  display: block;
}

.content .date-labels,
.content .photo-label {
  padding-bottom: 0;
}

.content .date-labels > div,
.content .photo-label > div {
  padding-bottom: 0;
}

.content .date-pickers > div,
.content .photo-picker > div {
  padding-top: 0;
}

label#browse-btn {
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 1px 5px rgba(120, 120, 120, 0.25);
  border-radius: 5px;
  color: #9b9b9b;
  padding: 10px;
  margin-bottom: 0;
}

input[type="text"],
input[type="number"],
input[type="date"],
textarea,
select {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}

.error-msg {
  font-size: 10px;
  color: #ea6254;
  margin-top: 5px;
}
</style>
